module.exports = __webpack_public_path__ + "img/DQ-Filml.8135bb5b.jpg";